function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from "@apollo/client";
import { useFocusEffect, useNavigation, useNavigationState, useRoute } from "@react-navigation/core";
import hexToRgba from "hex-to-rgba";
import { produce } from "immer";
import random from "lodash/random";
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { ScrollView } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { AnimatedProgressCircle } from "@oui/app-core/src/components/AnimatedProgressCircle";
import { Button } from "@oui/app-core/src/components/Button";
import { HeaderButtons, HeaderItem } from "@oui/app-core/src/components/HeaderButtons";
import { Markdown } from "@oui/app-core/src/components/Markdown";
import { FullscreenMediaPlayer } from "@oui/app-core/src/components/MediaPlayer";
import { Label } from "@oui/app-core/src/components/Text";
import { View } from "@oui/app-core/src/components/View";
import { SelfPatientQuery, useCurrentPatient } from "@oui/app-core/src/hooks/useCurrentUser";
import { usePersistedState } from "@oui/app-core/src/hooks/usePersistedState";
import { useWindowDimensions } from "@oui/app-core/src/hooks/useWindowDimensions";
import { logEvent } from "@oui/app-core/src/lib/log";
import { QuizSet } from "@oui/app-core/src/screens/QuizSet";
import { useTheme } from "@oui/app-core/src/styles";
import { OTX601_URI_BY_FILENAME } from "@oui/lib/src/content/quizSet/quizSetDataStaticOTX601";
import { getStaticSession } from "@oui/lib/src/getStaticSession";
import { graphql } from "@oui/lib/src/graphql/tada";
import { useStaticContext } from "../components/StaticContext";
import { StaticSessionCover } from "../components/StaticSessionCover";
function useStopwatch() {
    var timeout = useRef(undefined);
    var startMs = useRef(0);
    var _useState = _sliced_to_array(useState(0), 2), durationMs = _useState[0], setDurationMs = _useState[1];
    useEffect(function() {
        return function() {
            return clearTimeout(timeout.current);
        };
    }, []);
    var start = useCallback(function() {
        function advance() {
            startMs.current = Date.now();
            timeout.current = setTimeout(function() {
                setDurationMs(function(dur) {
                    var newDur = dur + (Date.now() - startMs.current);
                    advance();
                    return newDur;
                });
            }, 250);
        }
        advance();
    }, []);
    var stop = useCallback(function() {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = undefined;
            setDurationMs(function(dur) {
                return dur + (Date.now() - startMs.current);
            });
        }
    }, []);
    return {
        start: start,
        stop: stop,
        durationMs: durationMs
    };
}
export var SetStaticSessionCompleteMutation = graphql("\n  mutation SetStaticSessionComplete($content: ContentType!) {\n    setOuiProgress(content: $content, value: 1) {\n      content\n      completion\n      completed\n      updatedAt\n    }\n  }\n");
function ProgressBar(param) {
    var completion = param.completion;
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(View, {
        style: {
            height: 6,
            left: 0,
            right: 0,
            top: 0,
            position: 'absolute',
            backgroundColor: hexToRgba(theme.color.accentTwo100, 0.3)
        },
        children: /*#__PURE__*/ _jsx(View, {
            style: {
                left: 0,
                width: "".concat(completion, "%"),
                height: '100%',
                backgroundColor: theme.color.accentTwo100
            }
        })
    });
}
export function StaticSession() {
    var IS_TESTING = global.e2e || process.env.STORYBOOK_CLIENT;
    var delayFn = useStaticContext().delayFn;
    var theme = useTheme().theme;
    var insets = useSafeAreaInsets();
    var _useMutation = _sliced_to_array(useMutation(SetStaticSessionCompleteMutation), 1), setStaticSessionComplete = _useMutation[0];
    var role = useCurrentPatient();
    var navigation = useNavigation();
    var route = useRoute();
    var contentType = route.params.slug;
    var _route_params_page;
    var pageIndex = Number.parseInt((_route_params_page = route.params.page) !== null && _route_params_page !== void 0 ? _route_params_page : 0);
    var _usePersistedState = _sliced_to_array(usePersistedState('staticSessionCurrentPages', {}), 2), setStaticSessionPages = _usePersistedState[1];
    var previousRoute = useNavigationState(function(state) {
        var firstStaticSession = state.routes.findIndex(function(r) {
            return r.name === 'StaticSession';
        });
        if (firstStaticSession !== -1 && firstStaticSession !== 0) {
            return state.routes[firstStaticSession - 1];
        }
        return null;
    });
    var width = useWindowDimensions().width;
    var _useStopwatch = useStopwatch(), durationMs = _useStopwatch.durationMs, start = _useStopwatch.start, stop = _useStopwatch.stop;
    useEffect(function() {
        start();
    }, [
        start
    ]);
    useFocusEffect(useCallback(function() {
        setStaticSessionPages(function(staticSessionPages) {
            return produce(staticSessionPages, function(draft) {
                draft[contentType] = pageIndex;
            });
        });
    }, [
        contentType,
        pageIndex,
        setStaticSessionPages
    ]));
    useLayoutEffect(function() {
        navigation.setOptions({
            headerRight: previousRoute ? function(param) {
                var tintColor = param.tintColor;
                var _route_params_previousScreenIcon;
                return /*#__PURE__*/ _jsx(HeaderButtons, {
                    children: /*#__PURE__*/ _jsx(HeaderItem, {
                        testID: "StaticSession_exitButton",
                        "aria-label": "Leave session",
                        iconName: (_route_params_previousScreenIcon = route.params.previousScreenIcon) !== null && _route_params_previousScreenIcon !== void 0 ? _route_params_previousScreenIcon : 'home',
                        title: "",
                        color: tintColor,
                        onPress: function() {
                            navigation.navigate({
                                key: previousRoute === null || previousRoute === void 0 ? void 0 : previousRoute.key
                            });
                        }
                    })
                });
            } : function() {
                return null;
            }
        });
    }, [
        navigation,
        route.params,
        previousRoute
    ]);
    var nextPageTimeoutRef = useRef(undefined);
    useEffect(function() {
        return function() {
            return clearTimeout(nextPageTimeoutRef.current);
        };
    }, [
        route.params.page
    ]);
    // memoize rules so that Markdown doesn't re-render on every tick of durationMs
    var rules = useMemo(function() {
        return {
            link: function(node) {
                return /*#__PURE__*/ _jsx(View, {
                    style: {
                        width: width - 40 * 2
                    },
                    children: /*#__PURE__*/ _jsx(FullscreenMediaPlayer, {
                        uri: OTX601_URI_BY_FILENAME[node.attributes.href]
                    })
                });
            }
        };
    }, [
        width
    ]);
    if (!role) return null;
    var session = getStaticSession({
        contentType: contentType,
        productSlug: role.product.slug,
        roleType: role.roleType,
        productStatic: role.productStatic
    });
    var content = session[pageIndex];
    var completion = Math.floor(pageIndex / (session.length - 1) * 100);
    var hasNextPage = pageIndex < session.length - 1;
    var patientID = role.ID;
    var delayDuration = typeof content === 'string' ? delayFn({
        content: content,
        contentType: contentType,
        pageIndex: pageIndex
    }) : 0;
    if (durationMs > delayDuration) {
        stop();
    }
    function markAsComplete() {
        return _markAsComplete.apply(this, arguments);
    }
    function _markAsComplete() {
        _markAsComplete = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setStaticSessionPages(function(staticSessionPages) {
                            return produce(staticSessionPages, function(draft) {
                                delete draft[contentType];
                            });
                        });
                        return [
                            4,
                            setStaticSessionComplete({
                                variables: {
                                    content: contentType
                                },
                                update: function(cache, result) {
                                    var _result_data, _data_user;
                                    var data = cache.readQuery({
                                        query: SelfPatientQuery,
                                        variables: {
                                            patientID: patientID
                                        }
                                    });
                                    var newProgress = (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.setOuiProgress;
                                    if (newProgress && (data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : _data_user.role)) {
                                        var newData = produce(data, function(draft) {
                                            var _draft_user;
                                            if (draft === null || draft === void 0 ? void 0 : (_draft_user = draft.user) === null || _draft_user === void 0 ? void 0 : _draft_user.role) {
                                                draft.user.role.progress = _to_consumable_array(draft.user.role.progress.filter(function(p) {
                                                    return p.content !== contentType;
                                                })).concat([
                                                    newProgress
                                                ]);
                                            }
                                        });
                                        cache.writeQuery({
                                            query: SelfPatientQuery,
                                            variables: {
                                                patientID: patientID
                                            },
                                            data: newData
                                        });
                                    }
                                }
                            }).then(function() {
                                return logEvent("session_completed", {
                                    session: contentType
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _markAsComplete.apply(this, arguments);
    }
    function onNext() {
        return _onNext.apply(this, arguments);
    }
    function _onNext() {
        _onNext = _async_to_generator(function() {
            var newPage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newPage = pageIndex + 1;
                        if (!(role === null || role === void 0 ? void 0 : role.productStatic)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            new Promise(function(res) {
                                nextPageTimeoutRef.current = setTimeout(res, IS_TESTING ? 500 : random(2, 4) * 1000);
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        navigation.push('StaticSession', _object_spread_props(_object_spread({}, route.params), {
                            page: newPage.toString()
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _onNext.apply(this, arguments);
    }
    if (typeof content !== 'string') {
        switch(content.type){
            case 'QuizSet':
                return /*#__PURE__*/ _jsx(QuizSet, {
                    slug: content.slug,
                    onDone: function() {
                        return void onNext();
                    }
                });
            case 'SessionCover':
                return /*#__PURE__*/ _jsx(View, {
                    style: {
                        flex: 1,
                        paddingBottom: insets.bottom
                    },
                    children: /*#__PURE__*/ _jsx(StaticSessionCover, {
                        title: content.title,
                        onBack: navigation.goBack,
                        onNext: function() {
                            return void onNext();
                        }
                    })
                });
        }
    }
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            flex: 1,
            paddingBottom: insets.bottom
        },
        children: [
            /*#__PURE__*/ _jsxs(ScrollView, {
                style: {
                    flex: 1
                },
                contentContainerStyle: {
                    paddingHorizontal: 40,
                    paddingTop: 20,
                    paddingBottom: 20
                },
                testID: "StaticSession_".concat(pageIndex),
                children: [
                    /*#__PURE__*/ _jsx(Markdown, {
                        rules: rules,
                        children: content
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        row: true,
                        style: {
                            marginTop: 20,
                            justifyContent: 'flex-end'
                        },
                        children: role.productStatic && durationMs < delayDuration ? /*#__PURE__*/ _jsxs(View, {
                            style: {
                                borderRadius: 100,
                                paddingHorizontal: 15,
                                paddingVertical: 10,
                                backgroundColor: theme.color.gray800,
                                gap: 10,
                                flexDirection: 'row'
                            },
                            // @ts-expect-error
                            dataSet: {
                                chromatic: 'ignore'
                            },
                            children: [
                                /*#__PURE__*/ _jsx(AnimatedProgressCircle, {
                                    text: "",
                                    progress: durationMs / delayDuration,
                                    size: 20,
                                    strokeWidth: 2,
                                    color: theme.color.gray100
                                }),
                                /*#__PURE__*/ _jsx(Label, {
                                    small: true,
                                    text: "".concat(Math.floor((delayDuration - durationMs) / 1000), "s")
                                })
                            ]
                        }) : hasNextPage ? /*#__PURE__*/ _jsx(Button, {
                            testID: "StaticSession_nextButton",
                            text: "Next",
                            onPress: onNext
                        }) : /*#__PURE__*/ _jsx(Button, {
                            testID: "StaticSession_finishButton",
                            text: "Finish",
                            onPress: /*#__PURE__*/ _async_to_generator(function() {
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                markAsComplete()
                                            ];
                                        case 1:
                                            _state.sent();
                                            if (previousRoute) {
                                                navigation.navigate({
                                                    key: previousRoute.key
                                                });
                                            } else {
                                                navigation.goBack();
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })
                        })
                    })
                ]
            }),
            role.productStatic ? null : /*#__PURE__*/ _jsx(ProgressBar, {
                completion: completion
            })
        ]
    });
}
